import { useQuery } from '@tanstack/react-query';
import { GatheringRequests } from 'src/requests/gathering';
import { QueryKey } from 'src/utils/react-query';

export const useGatheringChatQuery = ({
  sessionRef,
}: { sessionRef: string }) => {
  const queryKey = [QueryKey.GATHERING, sessionRef, 'chat'];

  const {
    data: gatheringChat,
    isFetching,
    refetch,
  } = useQuery({
    enabled: !!sessionRef,
    queryKey,
    queryFn: () => GatheringRequests.getGatheringChat(sessionRef),
    refetchOnWindowFocus: false,
  });

  return {
    gatheringChat,
    isFetching,
    refetch,
  };
};
